import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "icn-channel",
  templateUrl: "./channel.component.html",
  styleUrls: ["./channel.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChannelComponent {}
